import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from 'projects/app-default/src/app/catalog/model/product/product.decorator';
@Component({
    selector: 'builder-product',
    templateUrl: 'builder-product.html',
    standalone: true,
    imports: [ImageModule, TranslationModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuilderProductComponent implements OnChanges {
    @Input()
    model?: LocalProduct<IProductDataV2>;
    private swatchAttribute = 'color';
    protected swatchesCount?: number;
    ngOnChanges() {
        this.swatchesCount = this.model?.getConfigurableAttributeOptions(this.swatchAttribute).length || 1;
    }
}
